const COOKIES_NAMES = {
  Consents: 'cookie-consent',
  RegisteredUser: 'skouting_registered_user',
  FirstVisitDate: 'skouting_page_accessed_stamp',
};

export default COOKIES_NAMES;
